import { Features } from 'generated/featureDefinitions'

import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import { useFeatures } from 'modules/core/hooks/useFeatures'

export const useEvaluationFormsFeatureAvailability = () => {
  const { has_dev_packaging_paywalls, has_ats_evaluation_forms } = useFeatures([
    'dev_packaging_paywalls',
    'ats_evaluation_forms',
  ])
  const { featureAvailability } = useFeatureAvailability(Features.ats_evaluation_forms)

  return has_dev_packaging_paywalls ? featureAvailability.available : has_ats_evaluation_forms
}
